import { css } from '@emotion/react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Page403() {
  const navigate = useNavigate();

  return (
    <div css={containerStyle}>
      <Result
        status='403'
        title='403'
        subTitle='Bạn không có quyền truy cập trang này.'
        extra={
          <Button type='primary' onClick={() => navigate('/')}>
            Quay về trang chủ
          </Button>
        }
      />
    </div>
  );
}

const containerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f9fa;
`;
